import { CareerProfileView } from './CareerProfileView'
export default CareerProfileView
